import { render, staticRenderFns } from "./PatientResultsRunning.vue?vue&type=template&id=6175f2d2&scoped=true&"
import script from "./PatientResultsRunning.vue?vue&type=script&lang=ts&"
export * from "./PatientResultsRunning.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../common/temp/node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6175f2d2",
  null
  
)

export default component.exports